<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar prospectos</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de prospectos.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Compañía</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allCompanies" name="allCompanies" (change)="toggleAllCompanies()">
            <span class="crm-checkbox-custom"></span>
            Todas las compañías
          </label>
          <div *ngFor="let company of availableCompanies" class="filter-option-item">
            <label class="crm-checkbox-label">
              <input type="checkbox" class="crm-checkbox" 
                     [(ngModel)]="filters.companies[company]" 
                     [name]="company"
                     (change)="onCompanyChange()">
              <span class="crm-checkbox-custom"></span>
              {{ company }}
            </label>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Cargo</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allPositions" name="allPositions" (change)="toggleAllPositions()">
            <span class="crm-checkbox-custom"></span>
            Todos los cargos
          </label>
          <div *ngFor="let position of availablePositions" class="filter-option-item">
            <label class="crm-checkbox-label">
              <input type="checkbox" class="crm-checkbox" 
                     [(ngModel)]="filters.positions[position]" 
                     [name]="position"
                     (change)="onPositionChange()">
              <span class="crm-checkbox-custom"></span>
              {{ position }}
            </label>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Estado del prospecto</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allStatus" name="allStatus" (change)="toggleAllStatus()">
            <span class="crm-checkbox-custom"></span>
            Todos los estados
          </label>
          <div *ngFor="let status of availableStatus" class="filter-option-item">
            <label class="crm-checkbox-label">
              <input type="checkbox" class="crm-checkbox" 
                     [(ngModel)]="filters.status[status]" 
                     [name]="status"
                     (change)="onStatusChange()">
              <span class="crm-checkbox-custom"></span>
              {{ status }}
            </label>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Fecha de creación</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="all">
            <span class="crm-radio-custom"></span>
            Todas las fechas
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="today">
            <span class="crm-radio-custom"></span>
            Hoy
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="7d">
            <span class="crm-radio-custom"></span>
            Últimos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="30d">
            <span class="crm-radio-custom"></span>
            Últimos 30 días
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Prospectos con teléfono</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="all">
            <span class="crm-radio-custom"></span>
            Todos los prospectos
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="withPhone">
            <span class="crm-radio-custom"></span>
            Con teléfono
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="withoutPhone">
            <span class="crm-radio-custom"></span>
            Sin teléfono
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Prospectos con email</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="emailFilter" [(ngModel)]="filters.emailFilter" value="all">
            <span class="crm-radio-custom"></span>
            Todos los prospectos
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="emailFilter" [(ngModel)]="filters.emailFilter" value="withEmail">
            <span class="crm-radio-custom"></span>
            Con email
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="emailFilter" [(ngModel)]="filters.emailFilter" value="withoutEmail">
            <span class="crm-radio-custom"></span>
            Sin email
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="clearFilters()">Limpiar filtros</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>